import noUiSlider from 'nouislider';

import { Offcanvas } from 'bootstrap';

export default {
  init() {
    // JavaScript to be fired on the home page
    Number.prototype.format = function(n, x, s, c) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
          num = this.toFixed(Math.max(0, ~~n));
  
      return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };
  
    var rangePrecio = document.getElementById('rangePrecio');

    if(rangePrecio){

      noUiSlider.create(rangePrecio, {
        start: [0, 9000000],
        step: 100,
        connect: true,
        range: {
          'min': 0,
          'max': 9000000,
        }
      });
      rangePrecio.noUiSlider.on('update', function (values, handle, unencoded, tap, positions, noUiSlider) { 
        
        $('.val-Precio').html( Number(values[0]).format(0, 3, '.', ',')+'€ hasta '+Number(values[1]).format(0, 3, '.', ',')+'€');
      });
      
      rangePrecio.noUiSlider.on('change', function (values, handle, unencoded, tap, positions, noUiSlider) { 
        $('#precio1').val(values[0]);
        $('#precio2').val(values[1]);
      });
      
    }

    $('.js-precio-movil-desde').change(function (e) { 
      $('#precio1').val(e.target.value);
    });

    $('.js-precio-movil-hasta').change(function (e) { 
      $('#precio2').val(e.target.value);
    });

    var rangeDistancia = document.getElementById('rangeDistancia');
    if(rangeDistancia){

    
      noUiSlider.create(rangeDistancia, {
          start: [3],
          step:1,
          connect: 'lower',
          range: {
              'min': 1,
              'max': 20
          }
      });

      rangeDistancia.noUiSlider.on('update', function (values, handle, unencoded, tap, positions, noUiSlider) { 

        $('.val-distancia').html( Number(values[0]).format(0, 3, '.', ',')+'Km');
      });

      rangeDistancia.noUiSlider.on('change', function (values, handle, unencoded, tap, positions, noUiSlider) { 

        $('#distancia').val(values[0]);
      });
    }

    //evento cambiar tipo de operacion
    $('#tipo_operacion').change(function (e) { 
      e.preventDefault();
      console.log('cambia tipo de operacion', e.target.value);
      if( e.target.value == 'OPE_A'){
        if(rangePrecio){
          rangePrecio.noUiSlider.updateOptions({
              range: {
                  'min': 0,
                  'max': 10000
              }
          });
          rangePrecio.noUiSlider.set([null, 10000]);
        }

        $('.movil-precios-venta').hide();
        $('.movil-precios-alquiler').show();
      }else{
        if(rangePrecio){
          rangePrecio.noUiSlider.updateOptions({
              range: {
                  'min': 0,
                  'max': 9000000
              }
          });
          rangePrecio.noUiSlider.set([null, 9000000]);
        }
        $('.movil-precios-venta').show();
        $('.movil-precios-alquiler').hide();
      }
    });


    
    if(document.getElementById('pac-input')){
      initAutocomplete();
    }

    

    $('.js-buscar').click(function (e) { 
      e.preventDefault();
      
      $('#page').val('1');

      clickBuscar(e);
     
    });



    var myOffcanvasMap = document.getElementById('offcanvasMap');
    if(myOffcanvasMap){
      var bsOffcanvasMap = new Offcanvas(myOffcanvasMap);
      $('.js-toglemapa').click(function (e) { 
        e.preventDefault();
        bsOffcanvasMap.toggle();
        window.document.activeElement.blur();
      });
    }


    var myOffcanvas = document.getElementById('offcanvasFiltros');
    if(myOffcanvas){
      var bsOffcanvas = new Offcanvas(myOffcanvas);
      $('.js-toglefilters').click(function (e) { 
        e.preventDefault();
        bsOffcanvas.toggle();
        window.document.activeElement.blur();
      });
    }



    window.addEventListener('popstate', function (event) {
      // Log the state data to the console
      console.log('POPSTATEEEEEEEE');
      if(myOffcanvas){
        var isOffcanvasVisible = $('#offcanvasFiltros').hasClass('show');
        console.log('isOffcanvasVisible', isOffcanvasVisible);
        if(isOffcanvasVisible){
          $(myOffcanvas).find('.btn-close').click();
        }
        window.document.activeElement.blur();
      }

      var data = getSearchParams();
      
      buscar(data);
    });
    
    if(document.getElementById('map')){
      refreshMarkers();
    }


    var data = getSearchParams();
    if(data!== false){
      buscar(data);
      $('#lat').val(data.lat);
      $('#lng').val(data.lng);
      $('#distancia').val(data.distancia);
      $('#page').val(data.page);
      $('#precio1').val(data.precio1);
      $('#precio2').val(data.precio2);
      $('#tipo_operacion').val(data.tipo_operacion);
      $('#tipo_vivienda').val(data.tipo_vivienda);
      $('#estado').val(data.estado);
      $('#tamano').val(data.tamano);
      $('#pac-input').val(data.localizacion);

      $('#tipo_operacion').change();
      if(rangeDistancia){
        rangeDistancia.noUiSlider.set(data.distancia);
      }
      if(rangePrecio){
        rangePrecio.noUiSlider.set([data.precio1, data.precio2]);
      }
    }
    //modal buscador
    // $('#modalFormulario').modal('show'); //movido a template-home.blade.php

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};


function clickBuscar(e){
  var data = $('#formBuscador').serialize();
  var qs = '#';
 // qs += $('#lat').val() + '/';
  // qs += $('#lng').val() + '/';
  // qs += $('#distancia').val() + '/';
  // qs += $('#page').val() + '/';
  // qs += $('#precio1').val() + '/';
  // qs += $('#precio2').val() + '/';
  // qs += $('#tipo_operacion').val() + '/';
  // qs += $('#tipo_vivienda').val() + '/';
  // qs += $('#estado').val() + '/';
  // qs += $('#tamano').val()+ '/';
  // qs += $('#pac-input').val();

  var operacion = $('#tipo_operacion').val();
  if(operacion == 'OPE VENTA-ALQUILER'){
    operacion = 'venta-alquiler';
  }else if(operacion == 'OPE_A'){
    operacion = 'alquiler';
  }else if(operacion == 'OPE_V'){
    operacion = 'venta';
  }else{
    operacion = '';
  }

  qs += operacion + '/';
  qs += $('#tipo_vivienda').val() + '/';
  qs += $('#pac-input').val() + '/';
  qs += $('#estado').val() + '/';
  qs += $('#lat').val() + '/';
  qs += $('#lng').val() + '/';
  qs += $('#distancia').val() + '/';
  qs += $('#page').val() + '/';
  qs += $('#precio1').val() + '/';
  qs += $('#precio2').val() + '/';
  qs += $('#tamano').val()+ '/';


  console.log(qs);
  self.location = '/busqueda/'+qs;
}


function buscar(data){
  $.ajax({
    type: "POST",
    url: "/wp-admin/admin-ajax.php",
    data: data,
    dataType: "json",
    success: function (response) {
      console.log(response);
      if(response.success){
        $('.js-listado').html(response.html);
        $('.js-msg').html(response.msg);

        $('.js-cont-paginacion').html(response.paginacion);

        if(document.getElementById('map')){
          refreshMarkers();
        }
      }
    }
  });
}
function getSearchParams(){
  var url = self.location.href;
  var qs = url.split('#');
  if(qs.length<=1){
    return false;
  }
  var params = qs[1].split('/');

  var data = {
    action: 'homeBuscar',
    tipo_operacion: decodeURI(params[0]),
    tipo_vivienda: decodeURI(params[1]),
    localizacion: decodeURI(params[2]),
    estado: decodeURI(params[3]),
    lat: params[4],
    lng: params[5],
    distancia: params[6],
    page: params[7],
    precio1: params[8],
    precio2: params[9],
    tamano: params[10]
  };

  if(data.tipo_operacion=='venta-alquiler'){
    data.tipo_operacion= 'OPE VENTA-ALQUILER';
  }else if(data.tipo_operacion=='alquiler'){
    data.tipo_operacion= 'OPE_A';
  }else if(data.tipo_operacion=='venta'){
    data.tipo_operacion= 'OPE_V';
  }else{
    data.tipo_operacion = '';
  }

  return data;
}

function initAutocomplete() {
      console.log('INIT AUTOCOMPLETE');
  // Create the search box and link it to the UI element.
  const input = document.getElementById("pac-input");
  const searchBox = new google.maps.places.SearchBox(input);

  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  searchBox.addListener("places_changed", () => {
    const places = searchBox.getPlaces();

    if (places.length == 0) {
      return;
    }

    var place = places[0];

    $('#lat').val(place.geometry.location.lat());
    $('#lng').val(place.geometry.location.lng());
  });


  
}
var prev_infowindow =false; 
var markers = [];
var cityCircle = null;
function refreshMarkers(){
  clearMarkers();

  var bounds = new google.maps.LatLngBounds();

  $('.cont-inmueble').each(function (index, element) {
    // element == this
    var id = $(this).data('id');
    var lat = $(this).data('lat');
    var lng = $(this).data('lng');
    var label = $(this).data('label');
    var title = $(this).data('title');
    var preciso = $(this).data('preciso');
    var img = $(this).find('.foto-portada').attr('src');
    var precio = $(this).find('.js-precio').html();
    var myLatLng = { lat: parseFloat(lat), lng: parseFloat(lng) };
    var url = $(this).find('.main-link').attr('href');
    console.log('---');
    console.log(title);
    console.log(myLatLng);
    
    var url_icon = (preciso=='1') ? '/wp-content/themes/templatePLG/dist/images/marker.png':'/wp-content/themes/templatePLG/dist/images/marker-nopreciso.png'

   var marker = new google.maps.Marker({
      position: myLatLng,
      map,
      title: title,
      label: {
        text: label,
        color: 'white',
        className: 'marker-position',
      },
      icon: url_icon,
    });
    marker.metadata = {id: id};
    google.maps.event.addListener(marker,"click",clicMarker);
    markers.push(marker);
 
    bounds.extend(myLatLng);


    var content = '<div class="infow-custom">';
    content += '<div class="imagen"><img src="'+ img +'"></div>';
      content += '<div class="texto">';
        content += '<div class="titulo">';
          content += title;
        content += '</div>';
        content += '<div class="precio">';
          content += precio;
        content += '</div>';

        content += '<div class="boton d-md-none">';
          content += '<a href="'+url+'">Ver detalle</a>';
        content += '</div>';
             
      content += '</div>';     
    content += '</div>';     

    var infowindow = new google.maps.InfoWindow()
  
    google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){ 
          return function() {
            
            if( prev_infowindow ) {
              prev_infowindow.close();
           }
   
           prev_infowindow = infowindow;
             infowindow.setContent(content);
             infowindow.open(map,marker);
             document.getElementById('inmueble-'+marker.metadata.id).scrollIntoView();

          };
      })(marker,content,infowindow)); 


  });

 var data = getSearchParams();

  if(data !== false && data.lng!=''){

    cityCircle = new google.maps.Circle({
      strokeColor: "#28A89F",
      strokeOpacity: 0.6,
      strokeWeight: 1,
      fillColor: "#28A89F",
      fillOpacity: 0.1,
      map,
      center: { lat: parseFloat(data.lat), lng: parseFloat(data.lng) },
      radius: parseInt(data.distancia)*1000,
    });
    
    map.fitBounds(cityCircle.getBounds());
  }else{
    map.fitBounds(bounds);
  }
}

function clearMarkers() {
  for (var i = 0; i < markers.length; i++ ) {
    markers[i].setMap(null);
  }
  markers.length = 0;
  if(cityCircle!=null){
    cityCircle.setMap(null);
  }

}

function clicMarker(event){
  console.log(this.metadata.id);
}


window.irPagina=function(pag){
  console.log(pag);
  $('#page').val(pag);
  // $('.js-buscar').click();
  clickBuscar()

}


// WEBPACK FOOTER //
// ./scripts/routes/busqueda.js